module.exports = __webpack_public_path__ + "images/xibao_top_backview_2025.1787648603550.jpg";